module.exports = __webpack_public_path__ + "public/img/bar-4.26107ae6.png";